export default {
  methods: {
    async validarDeploy () {
      try {
        const { data } = await this.$http.get('/verifica-deploy')

        if (data.em_deploy) {
          this.$store.commit('setDeployStatus', true)
          return false
        }
        this.$store.commit('setDeployStatus', false)
        return true
      } catch (error) {
        console.error('Erro ao verificar status do deploy:', error)
        return true
      }
    }
  }
}
